import { prefix } from '@goldwasserexchange/react-topmodel';

export const textInputPrefixer = prefix('Text');
